import { render, staticRenderFns } from "./AccordionFlow.vue?vue&type=template&id=8741f566"
import script from "./AccordionFlow.vue?vue&type=script&lang=js"
export * from "./AccordionFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports